import React from "react";
import { svg } from "../../Assets/svg";

interface UploadedSampleFileDisplayProps {
  file: File;
  loading?: boolean;
  onRemove: (e: React.MouseEvent) => void;
  containerStyle?: React.CSSProperties;
}

const UploadedSampleFileDisplay: React.FC<UploadedSampleFileDisplayProps> = ({
  file,
  loading = false,
  onRemove,
  containerStyle,
}) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center position-relative"
      style={{
        border: "2px dashed #d9d9d9",
        backgroundColor: "#fafafa",
        padding: "20px 0",
        marginBottom: "30px",
        ...containerStyle, // Allow overriding styles
      }}
    >
      <div className="d-flex flex-column align-items-center">
        {/* Close/Remove Button */}
        <span
          className={`position-absolute top-0 end-0 m-2 d-inline-block lh-m ${
            loading ? "opacity-25" : "cursor-pointer"
          }`}
          onClick={onRemove}
          style={{
            cursor: loading ? "not-allowed" : "pointer",
            pointerEvents: loading ? "none" : "auto",
          }}
          title={loading ? "Processing..." : "Remove file"}
        >
          {svg?.removeIcon || "X"}
        </span>

        {/* File Icon */}
        <span style={{ fontSize: "48px", color: "#ccc" }}>{svg?.fileIcon}</span>

        {/* File Name */}
        <p className="mt-2 mb-0 fw-semibold">{file.name}</p>

        {/* Loading Status */}
        {loading && (
          <span className="text-primary fs-12 mt-1">Processing...</span>
        )}
      </div>
    </div>
  );
};

export default UploadedSampleFileDisplay;
